<template>
    <div>
        <div>
            <div class="common-search">
                <el-date-picker
                        v-model="date"
                        format="yyyy-MM-dd HH:mm"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"/>
                <el-button type="primary" @click="getList()">搜索</el-button>
                <el-button v-if="permissions.osm_room_info_export" type="success" @click="exportFunc">导出</el-button>

            </div>
        </div>

        <div>
            <strong class="common-text-item" v-text="`总带入：${platformRoomStats.totalBring/100}`"></strong>
            <strong class="common-text-item" v-text="`总保险：${platformRoomStats.totalInsurance /100}`"></strong>
            <strong class="common-text-item" v-text="`总手数：${platformRoomStats.totalHands}`"></strong>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="platformRoomStats.beanList"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="房间ID" width="120" align="center" prop="roomId"/>
                <el-table-column label="房间名称" width="150" align="center" prop="roomName"/>
                <el-table-column label="是否开启保险" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.insurance?'是':'否'}}</template>
                </el-table-column>
              <el-table-column label="房间类型" width="120" align="center">
                <template slot-scope="scope">{{clubRoomTypeVal(scope.row.clubRoomType)}}</template>
              </el-table-column>
                <el-table-column label="保险池" align="center">
                  <template slot-scope="scope">{{scope.row.insurancePool|numberChip}}</template>
                </el-table-column>
                <el-table-column label="用户ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称" width="150" align="center" prop="userNickname"/>
                <el-table-column label="联盟" width="150" align="center" prop="tribeName"/>
                <el-table-column label="俱乐部" width="180" align="center" prop="clubName"/>
                <el-table-column label="带入" align="center" prop="bring">
                  <template slot-scope="scope">{{scope.row.bring|numberChip}}</template>
                </el-table-column>
                <el-table-column label="盲注级别" align="center" prop="blind">
                  <template slot-scope="scope">{{scope.row.blind|blindNoteNumber}}</template>
                </el-table-column>
                <el-table-column label="手数" align="center" prop="hand"/>
                <el-table-column label="结束时间" width="150" align="center" prop="endTime"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="platformRoomStats.total"
                :current-page="currentPage"
                @current-change="getList({page:$event})"/>
    </div>
</template>
<script>
    import {mapState,mapMutations, mapActions} from 'vuex'
    export default {
        data() {
            return {
                loading:false,
                date: null,
                platformRoomStats: {// 平台牌局信息
                    beanList: [],
                    total: 0,
                    totalBring: 0,// 总带入
                    totalInsurance: 0,// 总保险
                    totalHands: 0,// 总手数
                },
                currentPage:1
            }
        },
        computed: {
            ...mapState('login', ['permissions']),
        },
        methods: {
            ...mapMutations('other',['setStateDownloadConfig']),
            ...mapActions('gameDetail', ['getPlatformRoomStats']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                return true
            },
            getList(obj = {}) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page: 1,
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getPlatformRoomStats(params).then(res=>{
                    this.platformRoomStats = res.data;
                    this.loading = false;
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action:'/gameDetail/platform/room/stats/export',
                    info:[
                        {name: 'startTime', value: this.date ? this.date[0] : ''},
                        {name: 'endTime', value: this.date ? this.date[1] : ''},
                    ]
                });
            },
          clubRoomTypeVal(val){
            if (val==0){
              return "大厅房间";
            }else if(val==1){
              return "俱乐部积分房";
            }else {
              return "大厅积分房";
            }
          },
        }
    }
</script>